import styled from '@emotion/styled';
import { css } from '@emotion/react';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';

import { NoGapSupport } from '../../lib/utils/mixins';

interface DropDownItemProps {
	selected: boolean;
}

const {
	spacing: {
		size_4px: { height: size_4 },
		size_8px: { height: size_8 },
		size_16px: { height: size_16 },
		size_20px: { height: size_20 },
		size_32px: { height: size_32 },
		size_160px: { height: size_160 }
	},
	color: colours
} = tokens;

export const DropDownItem = styled.button<DropDownItemProps>`
	border: none;
	cursor: pointer;
	display: flex;
	gap: ${size_8}px;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	text-align: left;
	padding: ${size_8}px ${size_16}px;
	min-width: ${size_160 + size_4 + size_32}px;
	background: ${colours.light.background_primary};
	transition: background-color 0.3s ease-in-out;
	white-space: nowrap;
	z-index: 0;
	color: ${colours.light.text_primary};

	&:hover,
	&:focus,
	&:active {
		background: ${colours.light.background_secondary};
		z-index: 1;
	}
`;

export const DropDownIcon = styled.span<DropDownItemProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${size_20}px;
	transition: opacity 0.3s ease-in-out;
	opacity: ${({ selected }) => (selected ? 1 : 0)};

	${NoGapSupport(
		() => css`
			margin: 0 0 0 ${size_8}px;
		`
	)}
`;
export const DropDownText = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`;

export const DropDownTextIcon = styled.div`
	display: inline;
	margin-inline-end: ${size_8}px;
`;
